/* eslint-disable react/display-name */
import { memo } from 'react';

import { lazyLoad } from 'utils/loadable';

import { TaxStatementRouting } from './taxStatement.routing';
export const TaxStatementComponent = memo(() => {
  return (
    <>
      <TaxStatementRouting />
    </>
  );
});

export const TaxStatementModule = lazyLoad(
  () => import('./taxStatement.module'),
  (module) => module.TaxStatementComponent
);
